import { useEffect } from "react";
import { goal, stage } from "@flights/et-universal";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData.js";
import web_flights_fd_genius_saving_badge_percentage from "../../../utils/experiments/genius/web_flights_fd_genius_saving_badge_percentage.js";
import { useTrackVICheckedBaggage } from "../../../utils/experiments/funnel/flights_funnel_web_vi_checked_baggage.js";
import useProfiler from "../../../hooks/useProfiler.js";
export function useFlightDetailsInnerEffectsDesktop(props) {
    const { flight, flightToken, fetchStatus, isError, trackV2, isRetryableFlightDetails } = props;
    const offerCartOrderData = useOfferCartOrderData();
    const { isLoggedIn, isDirect, isMeta, isDesktop, isMobile, isSolo } = useProfiler();
    const XM_SURVEY_EXP = "d_xm_flights_details";
    useEffect(() => {
        stage(XM_SURVEY_EXP, 1);
        if (isLoggedIn()) {
            stage(XM_SURVEY_EXP, 2);
        }
        else {
            stage(XM_SURVEY_EXP, 3);
        }
        if (isDirect()) {
            stage(XM_SURVEY_EXP, 4);
        }
        else if (isMeta()) {
            stage(XM_SURVEY_EXP, 5);
        }
    }, [XM_SURVEY_EXP, isLoggedIn, isDirect, isMeta]);
    useEffect(() => {
        const { parentOfferToken } = offerCartOrderData.get(flightToken);
        offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: parentOfferToken || flightToken });
    }, [flightToken, offerCartOrderData]);
    useEffect(() => {
        if (isLoggedIn() && flight) {
            web_flights_fd_genius_saving_badge_percentage.stages.land_on_fd();
        }
    }, [flight, isLoggedIn, isDesktop, isMobile, isSolo]);
    useEffect(() => {
        if (fetchStatus === "failed") {
            trackV2("show_error_page");
        }
    }, [fetchStatus, flight, isRetryableFlightDetails, trackV2]);
    useEffect(() => {
        if (isError)
            goal("flights_flight_details_loading_error");
    }, [isError]);
    useTrackVICheckedBaggage();
    return {};
}
